import { createSlice } from '@reduxjs/toolkit'
import { ROUTES } from '../config/routes'
import { GEOGRAPHIES } from '../pages/pricing-matrix/pricingMatrixData';

const PM_STEP = ROUTES.PRICING_MATRIX.PRICING_MATRIX_STEP;

export const PM_ENGAGEMENT_TYPE = {
    QUANTITATIVE: "Quantitative",
    QUALITATIVE: "Qualitative",
}
export const initialState = {
    industry: null,
    engagementType: PM_ENGAGEMENT_TYPE.QUANTITATIVE,
    [PM_STEP.GEOGRAPHIES]: [GEOGRAPHIES.NORTH_AMERICA],
    [PM_STEP.TITLES]: [],
    [PM_STEP.IRLEVEL]: [],
    [PM_STEP.LOI]: null,
    [PM_STEP.TARGETABLE_SCREENERS]: " ",
    targetingEnabled: false,
    patientsCriteria: false,
    pricingMatrixCalculatedData: null
}



export const sliceName = "PricingMatrixSlice"



export const pricingMatrixSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        handleTargetableScreeners: (state, action) => {
            const screener = action.payload
            if (state.targetable_screeners.includes(screener)) {
                return { ...state, targetable_screeners: state.targetable_screeners.replace("screener", "") }
            }
            else {
                return {
                    ...state,
                    targetable_screeners: screener
                }
            }
        },
        handleEngagementType: (state, action) => {
            const engagementType = action.payload;
            return { ...state, engagementType };
        },
        handleTargetingEnabled: (state, action) => {
            return {
                ...state,
                targetingEnabled: action.payload.targetingApplied,
            }
        },
        handlePMIRLevel: (state, action) => {
            if (state.ir_level.includes(action.payload)) {
                return { ...state, ir_level: state.ir_level.filter(ir => ir !== action.payload) }
            }
            else {
                return { ...state, ir_level: [...state.ir_level, action.payload] }
            }
        },
        handleTitle: (state, action) => {
            if (state.titles.includes(action.payload)) {
                return { ...state, titles: state.titles.filter(title => title !== action.payload) }
            }
            else {
                return { ...state, titles: [...state.titles, action.payload] }
            }
        },
        handleSetDefaultTitle: (state, action) => {
            if (!state.titles.includes(action.payload)) {
                return { ...state, titles: [...state.titles, action.payload] }
            }
        },
        handlePMAudience: (state, action) => {
            return { ...state, industry: action.payload }
        },

        handlePMLOI: (state, action) => {
            return { ...state, loi: action.payload }
        },
        handleDefaultLOI: (state, action) => {
            return { ...state, loi: action.payload }
        },
        handlePMGeography: (state, action) => {
            if (state.geographies.includes(action.payload)) {
                return { ...state, geographies: state.geographies.filter(geography => geography !== action.payload) }
            }
            else {
                return { ...state, geographies: [...state.geographies, action.payload] }
            }

        },
        handlePatientsCriteria: (state, action) => {
            return { ...state, patientsCriteria: action.payload }
        },
        handleCalculatedData: (state, action) => {
            return { ...state, pricingMatrixCalculatedData: action.payload };
        },
        handlePMReset: (state, action) => {
            if (action.payload) { // there is only one case when there is a payload in action: when we are passing "Engagement Type" to it.
                return { ...initialState, engagementType: action.payload };
            }
            return initialState
        }
    },
})

export const pricingMatrixDataState = state => state[sliceName]


// Action creators are generated for each case reducer function
export const { handlePMReset, handleEngagementType, handlePatientsCriteria, handleTargetableScreeners, handleTargetingEnabled, handleCalculatedData, handlePMIRLevel, handleTitle, handleSetDefaultTitle, handlePMAudience, handlePMGeography, handlePMLOI, handleDefaultLOI, handlePMisEmpty, handlePMAudienceTitle } = pricingMatrixSlice.actions

export default pricingMatrixSlice.reducer